import { MesfModal } from "@dexteel/mesf-core";
import { Button, Grid2 as Grid, Paper, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

interface Props {
	comments: string | null;
	onHide: () => void;
	open: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
	commentBox: {
		border: "1px solid #ced4da",
		borderRadius: 4,
		padding: theme.spacing(2),
		backgroundColor: "#fff",
		minHeight: 100,
		overflowY: "auto",
		pointerEvents: "none",
	},
}));
export const CommentsModal = ({ comments, onHide, open }: Props) => {
	const classes = useStyles();
	return (
		<>
			<MesfModal
				open={open}
				handleClose={onHide}
				id="comments-modal"
				title="Comment"
				maxWidth="sm"
			>
				<MesfModal.Content>
					<Grid container>
						<Grid size={{ xs: 12 }}>
							<div className={classes.commentBox}>
								<Typography>{comments}</Typography>
							</div>
						</Grid>
					</Grid>
				</MesfModal.Content>
				<MesfModal.Actions>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid size={{ xs: 3, md: 3 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="primary"
								onClick={onHide}
								size="small"
							>
								Ok
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
